import { useQuery, useMutation } from "react-query";
import {
	add_opa_commission_api,
	get_opa_commission_api,
	get_contact_details_api,
	update_contact_details_api,
} from "../services/settings";

export const useGetOpaCommission = () =>
	useQuery(["getOpaCommission"], () => get_opa_commission_api());

export const useAddOpaCommission = () =>
	useMutation("addOpaCommission", (body) => add_opa_commission_api(body));

export const useGetContactDetails = () =>
	useQuery(["getContactDetails"], () => get_contact_details_api());

export const useUpdateContactDetails = () =>
	useMutation("updateContactDetails", (body) =>
		update_contact_details_api(body)
	);
